module.exports = __webpack_public_path__ + "img/Menu-07.31d6f19b.png";